import propTypes from "prop-types";
export const optionsType = propTypes.arrayOf(
  propTypes.shape({
    value: propTypes.any,
    label: propTypes.any,
  })
);
